import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService, PositionLoader, ToastService, ToastType } from 'cve-ui';
import { forkJoin, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { B2cAuthenticationUseCaseService } from '../../features/authentication/aplication/b2c-authentication-use-case.service';

export const authGuard: CanActivateFn = () => {
    const authService = inject(B2cAuthenticationUseCaseService);
    const router = inject(Router);
    const loaderService = inject(LoaderService);
    const toastService = inject(ToastService);
    const translate = inject(TranslateService);
    let token: string | null = localStorage.getItem('token');
    const currentNavigation = router.getCurrentNavigation();
    const fragment = currentNavigation?.initialUrl.fragment;
    if (fragment?.includes('access_token')) {
        token = fragment.split('access_token=')[1];
        token = token.split('&')[0]
        localStorage.setItem('token', token);
    }
    if (!token) {
        forkJoin({
            title: translate.get('shared.toast.session_expired.title'),
            label: translate.get('shared.toast.session_expired.label'),
        }).subscribe(({ title, label }) => {
            toastService.show({
                type: ToastType.error,
                title,
                label,
            });
        });
        router.navigate(['/login']);
        return false;
    }

    if (authService.isTokenInRangeToRefresh()) {
        loaderService.show(PositionLoader.center);
        return authService.refreshToken().pipe(
            map(() => true),
            catchError(() => {
                authService.logout();
                return of(false);
            }),
            finalize(() => loaderService.hide())
        );
    }

    return true;
};
